<template>
  <div class="content">
    <div class="col-md-8 flex-container-top">
      <h2 class="text-center">Event Chat Rooms</h2>
    </div>

    <div class="row">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title">Active Event Chat Rooms</h4>

          <div class="text-center p-4" v-if="loading">
            <i class="fas fa-spinner fa-spin fa-2x"></i>
          </div>

          <div v-else>
            <div v-if="rooms.length === 0" class="text-center text-muted p-5">
              No active event chat rooms found.
            </div>

            <el-table :data="rooms" v-else>
              <el-table-column label="Event Details" :min-width="250">
                <div slot-scope="{ row }">
                  <strong>{{ (row.eventId && row.eventId.event_name) ? row.eventId.event_name : ('Event Room (ID: ' + (row.rawEventId || row.eventId || 'Unknown') + ')') }}</strong>
                  <div class="small text-muted mt-1" v-if="row.eventId">
                    <span class="badge badge-info mr-1" v-if="row.eventId.sport">{{ row.eventId.sport }}</span>
                    <span class="badge badge-warning mr-1" v-if="row.eventId.status">{{ row.eventId.status }}</span>
                    <span class="ml-1" v-if="row.eventId.start_time">{{ formatDate(row.eventId.start_time) }}</span>
                  </div>
                  <div class="small text-muted mt-1" v-else>
                    Chat ID: {{ row._id }}
                  </div>
                </div>
              </el-table-column>

              <el-table-column label="Last Message" :min-width="200">
                <div slot-scope="{ row }">
                  <span v-if="row.lastMessage">{{ row.lastMessage.content.substring(0, 60) }}</span>
                  <span v-else class="text-muted">No messages yet</span>
                </div>
              </el-table-column>

              <el-table-column label="Last Activity" :min-width="150">
                <div slot-scope="{ row }">{{ formatDate(row.lastActivity) }}</div>
              </el-table-column>

              <el-table-column label="Actions" align="right" :min-width="120">
                <div slot-scope="{ row }" class="text-right">
                  <base-button
                    type="primary"
                    size="sm"
                    @click="openRoom(row)"
                  >
                    Open Chat
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { Table, TableColumn } from "element-ui";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      loading: false,
      rooms: [],
    };
  },
  async mounted() {
    await this.fetchRooms();
  },
  methods: {
    async fetchRooms() {
      this.loading = true;
      try {
        const res = await this.$apiService.getCall("event-chat/rooms");
        const data = res.apidata.Data || {};
        this.rooms = data.data || [];
      } catch (e) {
        console.error("Error fetching event rooms", e);
      }
      this.loading = false;
    },
    openRoom(room) {
      // Always use the chat's own _id — works even if eventId doesn't exist in Events collection
      this.$router.push("/event_chat/room?chatId=" + room._id);
    },
    formatDate(d) {
      return d ? moment(d).format("DD-MM-YYYY hh:mm a") : "—";
    },
  },
};
</script>
